import React, { useState } from "react";
import { Helmet } from "react-helmet-async";

import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import HeroSection from "../../components/HeroSection/Hero";
import Contact from "../../components/Contact/ContactForm";

import HeroImage from "../../assets/images/orange-yellow.png";

import "./resources.css";

interface Resource {
  id: string;
  title: string;
  description: string;
  category: "brochure" | "user manual" | "datasheet";
  filePath: string;
  fileType: "pdf" | "doc" | "xls";
}

function Resources() {
  // Remove the intermediate icon variables
  
  const resources: Resource[] = [
    {
      id: "1",
      title: "BigBiz Brochure",
      description: "Our premium product line detailed brochure",
      category: "brochure",
      filePath: "/pdf/Brochure-BigBiz.pdf",
      fileType: "pdf"
    },
    {
      id: "2",
      title: "First Class Brochure",
      description: "Our premium product line detailed brochure",
      category: "brochure",
      filePath: "/pdf/Brochure-First-Class.pdf",
      fileType: "pdf"
    },
    {
      id: "3",
      title: "BigBiz User Manual",
      description: "Our premium product line detailed user manual",
      category: "user manual",
      filePath: "/pdf/Big-Biz-User-Manual.pdf",
      fileType: "pdf"
    },
    {
      id: "4",
      title: "First Class User Manual",
      description: "Our premium product line detailed user manual",
      category: "user manual",
      filePath: "/pdf/First-Class-User-Manual.pdf",
      fileType: "pdf"
    }
  ];

  const [filter] = useState<string>("all");

  // Filter resources
  const filteredResources = filter === "all" 
    ? resources 
    : resources.filter(resource => resource.category === filter);

  return (
    <div>
      <Helmet>
        <title>Resources</title>
      </Helmet>

      <Header />

      <HeroSection
        backgroundImage={HeroImage}
        title="Access our data sheets and operational guides here!"
        subtitle="Need more information?"
        dividerPath="M0,96L48,90.7C96,85,192,75,288,112C384,149,480,235,576,261.3C672,288,768,256,864,218.7C960,181,1056,139,1152,117.3C1248,96,1344,96,1392,96L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
        dividerColour="white"
      />
      
      <div className="resources-container">
        <div className="resources-header">
          <h2>Resource Library</h2>
          
          {/* actiate a filter */}
          {/* <div className="filter-controls">
            <select 
              value={filter} 
              onChange={(e) => setFilter(e.target.value)}
              className="filter-select"
            >
              <option value="all">All Resources</option>
              <option value="brochure">Brochures</option>
              <option value="usermanual">User Manuals</option>
              <option value="datasheet">Data Sheets</option>
            </select>
          </div> */}
        </div>
        
        <div className="resources-grid">
          {filteredResources.map((resource) => (
            <div key={resource.id} className="resource-card">
              <div className="resource-card-header">
                {/* Use the icon directly without variable */}
                <span className="resource-category">{resource.category}</span>
              </div>
              <div className="resource-card-content">
                <h3>{resource.title}</h3>
                <p>{resource.description}</p>
                <div className="resource-card-footer">
                  <a 
                    href={resource.filePath} 
                    target="_blank" 
                    rel="noreferrer"
                    className="download-btn"
                  >
                    Download
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="HomeContactContainer" style={{ padding: "0%" }}>
        <div className="HomeContactTitle">
          <h2>Got any more questions?</h2>
          <p>Let us know!</p>
        </div>
        <Contact />
      </div>

      <Footer />
    </div>
  );
}

export default Resources;